import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyB3ltzQXuq0S2bnFCo6vJZUpMQ0MJy1tdg",
  authDomain: "natakiya-com.firebaseapp.com",
  projectId: "natakiya-com",
  storageBucket: "natakiya-com.firebasestorage.app",
  messagingSenderId: "201179022239",
  appId: "1:201179022239:web:667449e08f1f3c066733aa",
  measurementId: "G-MEN9MPTB2E"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      console.log('Notification permission granted');
      return true;
    } else {
      console.log('Notification permission denied');
      return false;
    }
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    return false;
  }
};

export const getFCMToken = async () => {
  try {
    const token = await getToken(messaging, {
      vapidKey: 'BIsQCE-PXCg7MtvUD6vCoa6jb8D1GpII0xO881gRT2k9TaAvgk6PVPP_STz3bkZit4xEg8MgCOiSdotOByVRUas' // Get from Firebase Console
    });
    console.log('FCM Token:', token);
    return token;
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return null;
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log('Message received:', payload);
      resolve(payload);
    });
  });

export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const user = result.user;
    return {
      uid: user.uid,
      email: user.email,
      displayName: user.displayName,
      photoURL: user.photoURL,
      accessToken: await user.getIdToken()
    };
  } catch (error: any) {
    console.error('Google sign-in error:', error);
    throw error;
  }
};

export const signOutFromGoogle = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error('Sign out error:', error);
    throw error;
  }
};

export const playNotificationSound = () => {
  try {
    // Try to play custom sound
    const audio = new Audio('/notification-sound.mp3');
    audio.volume = 0.7;
    
    const playPromise = audio.play();
    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          console.log('🔊 Custom notification sound played');
        })
        .catch(error => {
          console.log('⚠️ Custom sound failed, using system beep:', error.message);
          // Fallback to system beep
          try {
            const AudioContextClass = window.AudioContext || (window as any).webkitAudioContext;
            if (AudioContextClass) {
              const context = new AudioContextClass();
              const oscillator = context.createOscillator();
              const gainNode = context.createGain();
              
              oscillator.connect(gainNode);
              gainNode.connect(context.destination);
              
              oscillator.frequency.value = 800;
              oscillator.type = 'sine';
              gainNode.gain.setValueAtTime(0.3, context.currentTime);
              gainNode.gain.exponentialRampToValueAtTime(0.01, context.currentTime + 0.5);
              
              oscillator.start(context.currentTime);
              oscillator.stop(context.currentTime + 0.5);
              
              console.log('🔊 System beep played');
            }
          } catch (beepError) {
            console.log('⚠️ System beep also failed:', beepError instanceof Error ? beepError.message : String(beepError));
          }
        });
    }
  } catch (error) {
    console.error('❌ Error playing notification sound:', error);
  }
};